import { v1 } from './v1';

export const status = {
  v1,
};
